import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

// Components
import { HeaderComponent } from './header/header.component';

// Guards
import { PlayGuard } from './guards/play/play.guard';

// Http
import { ApiService } from './http/api.service';
import { AppFunctionalitiesService } from './http/app-functionalities/app-functionalities.service';
import { ConfigService } from './http/config/config.service';
import { ActivationCodeService } from './http/activation-code/activation-code.service';
import { TrialService } from './http/trial/trial.service';

const COMPONENTS = [HeaderComponent];

const GUARDS = [PlayGuard];

const HTTP_SERVICES = [AppFunctionalitiesService, ConfigService, ActivationCodeService, TrialService];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, IonicModule],
  exports: COMPONENTS,
  providers: [...GUARDS, ApiService, ...HTTP_SERVICES],
})
export class CoreModule {}
